module.exports = __webpack_public_path__ + "static/img/li4_4.5e739005.png";